import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import ScoreIcon from "../svgs/scoreIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'scoreIncreaseElement',
  props: {
  totalScore: {
    type: Number,
    default: 3,
    required: true,
  },
  firstScore: {
    type: Number,
    default: 1.98,
    required: true,
  },
  excluded: {
    type: Boolean,
    default: false,
  },
},
  emits: ["open-advanced"],
  setup(__props, { emit }) {

const props = __props;





const secondScore = computed(() => {
  return +props.totalScore.toFixed(2) - +props.firstScore.toFixed(2);
});

const clickEvent = () => {
  emit("open-advanced");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "score_wrapper tw-cursor-pointer",
    onClick: clickEvent
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([__props.excluded ? 'tw-text-[#DBDBDB]' : '', "tw-flex tw-flex-wrap tw-gap-1 tw-font-medium tw-text-[11px] tw-items-center tw-text-[#878787]"])
    }, [
      _createTextVNode(_toDisplayString(__props.firstScore.toFixed(2)) + " ", 1),
      _createElementVNode("div", {
        class: _normalizeClass(["tw-text-[13px]", __props.excluded ? 'tw-text-[#DBDBDB]' : ''])
      }, " + ", 2),
      _createElementVNode("div", {
        class: _normalizeClass([__props.excluded ? 'tw-text-[#DBDBDB]' : '', "tw-text-[#01893D] tw-font-semibold"])
      }, _toDisplayString(secondScore.value.toFixed(2)), 3),
      _createElementVNode("div", {
        class: _normalizeClass([__props.excluded ? 'tw-text-[#DBDBDB]' : '', "tw-text-[13px]"])
      }, " = ", 2),
      _createVNode(ScoreIcon, {
        color: __props.excluded ? '#DBDBDB' : '#878787'
      }, null, 8, ["color"]),
      _createTextVNode(" " + _toDisplayString(Math.round(__props.totalScore * 100) / 100), 1)
    ], 2)
  ]))
}
}

})